import * as React from 'react';
import { Checkbox } from '../../../../ui/form/Checkbox';
import { FilterCheckboxWrapper, FilterComponentStyle } from './BaseAreaFilter';
import { SearchAggregation } from '../../../../../__types__/generated/cluster';

interface IArgs {
  parentKey?: string;
  options?: Partial<SearchAggregation>[];
  selected: IAreaOption[];
  onClick: (value: string, parent?: string) => void;
}

export interface IAreaOption {
  parentKey?: string;
  name: string;
}

export const AreaSubFilter: React.FC<IArgs> = React.memo(
  ({ parentKey, options, selected, onClick }) => {
    return (
      <FilterComponentStyle className="padding-left">
        {options
          ?.filter(
            (e) => e?.count && (parentKey ? e?.parentKey === parentKey : true)
          )
          ?.map((item, index) => {
            const { count = 0, key = null, parentKey } = item;
            if (!count || !key) return null;
            return (
              <FilterCheckboxWrapper key={`municipality_${index}`}>
                <Checkbox
                  checked={
                    selected.findIndex(
                      (e) => e?.name === key && e?.parentKey === parentKey
                    ) > -1
                  }
                  labelPos="right"
                  label={key}
                  count={count}
                  onClick={() => onClick(key, parentKey)}
                />
              </FilterCheckboxWrapper>
            );
          })}
      </FilterComponentStyle>
    );
  }
);
